import { Injectable, computed } from '@angular/core';
import { httpResource } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Kiosko } from '../../models/kiosko.model';

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class KioskoService {
  kioskoInfo = httpResource<Kiosko>(() => `${API_URL}/kioskos/me`);

  startRoute = computed<string>(() => {
    const tipo = this.kioskoInfo.value()?.tipoKiosko;
    if (tipo === 'AUTOSERVICIO') return '/v2/intencion';
    if (tipo === 'ATENCION_ASISTIDA') return '/v2/atencion-asistida';
    return '/v2/inicio';
  });
}
